import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Tecton_Graphql } from '.';
import { getRepoFilesQuery } from './queries/workspaceGraphql';
import { GetRepoFilesRequest } from './gql/graphql';

export const useGetRepoFiles = (options?: { enabled?: boolean }) => {
  const { workspace } = useParams<{ workspace: string }>();

  return useQuery(
    ['repo-files', workspace],
    async ({ signal }) => {
      const variables: { getRepoFilesRequest: GetRepoFilesRequest } = {
        getRepoFilesRequest: {
          workspace: workspace!,
        },
      };

      const response = await Tecton_Graphql.request({
        document: getRepoFilesQuery,
        variables,
        signal,
      });

      return response.GetRepoFiles;
    },
    {
      enabled: !!workspace && options?.enabled !== false,
      refetchOnWindowFocus: false,
    }
  );
};
